import React from "react";
import { EditIcon } from "../../../../../../../../../assets/Icons/EditIcon";
import { history } from "../../../../../../../../../history";
import { getPathParams } from "../../../../../utilities";
import styles from "./styles.module.scss";

export function Edit({ id }) {
  var { patientId } = getPathParams();

  return (
    <button
      className={styles.root}
      onClick={() => {
        history.push(`/clients/documents/edit/${id}/${patientId}/profile`);
      }}
    >
      <EditIcon width="18px" />
    </button>
  );
}
